import React from 'react';
import ChoiceKeys, { toKeyItems } from './ChoiceKeys';
import { statusTint, useTheme } from '../../lib/theme';

// StatusPicker — status choice inside a FORM (JobModal ops status, client
// intake status). Both modes now render ChoiceKeys with the status color
// ribbon (form-controls.md "Short list: B"); `mode="dropdown"` used to be
// a native <select> and is kept as an accepted prop so call sites don't
// have to change. `pills` is the small tinted-pill look for dense rows.
export default function StatusPicker({ statuses = [], value, onChange, mode = 'pills', disabled = false, size = 'sm', ariaLabel = 'Status' }) {
  if (mode === 'dropdown') {
    return (
      <ChoiceKeys
        items={toKeyItems(statuses)}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        ariaLabel={ariaLabel}
      />
    );
  }
  // Pills mode — compact tinted pills (status bg + color), whole pill is the target.
  const { isDark } = useTheme();
  const sizeClasses = size === 'xs' ? 'px-2.5 py-1 text-[10px] min-h-[28px]' : 'px-3 py-1.5 text-[11px] min-h-[32px]';
  return (
    <div role="radiogroup" aria-label={ariaLabel} className="flex items-center gap-1.5 flex-wrap">
      {statuses.map(s => {
        const isActive = value === s.key;
        return (
          <button
            key={s.key}
            type="button"
            role="radio"
            aria-checked={isActive}
            onClick={() => !disabled && onChange(s.key)}
            disabled={disabled}
            className={`${sizeClasses} rounded-lg font-bold transition-all ${isActive ? 'ring-2 ring-offset-1' : 'opacity-60 hover:opacity-100'} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            style={{
              background: statusTint(s.color, s.bg, isDark),
              color: s.color,
              ...(isActive ? { '--tw-ring-color': s.color } : {}),
            }}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
